import clsx from 'clsx';
import styles from './Spinner.module.css';

/** Inline activity mark for pending buttons; content areas use skeletons instead. */
export const Spinner = ({ className }: { readonly className?: string | undefined }) => (
  <span className={clsx(styles.spinner, className)} aria-hidden="true" />
);
